import { BodyL, PrimaryButton, SecondaryButton } from '@monthio/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ConfirmModalContainer = styled.div`
	padding: 16px 24px 20px;
`

const Row = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 20px;
	justify-content: center;

	> button {
		min-width: 150px;
	}
`

export const ConfirmAddDuplicate: React.FC<{
	assetType: 'realEstate' | 'vehicle'
	close: (confirmation: boolean) => void
}> = ({ assetType, close }) => {
	const { t } = useTranslation()
	const assetTypeTranslation = t(
		`assetOverview-type-${assetType}`,
	).toLowerCase()

	return (
		<ConfirmModalContainer>
			<BodyL>
				{t('asset-overview.add-asset.confirm-duplicate.title', {
					assetType: assetTypeTranslation,
				})}
			</BodyL>
			<Row>
				<PrimaryButton onClick={() => close(true)}>
					{t('btn-yes')}
				</PrimaryButton>
				<SecondaryButton onClick={() => close(false)}>
					{t('btn-cancel')}
				</SecondaryButton>
			</Row>
		</ConfirmModalContainer>
	)
}
